import { render } from "./reset-password-form.vue?vue&type=template&id=3f662c86"
import script from "./reset-password-form.vue?vue&type=script&lang=js"
export * from "./reset-password-form.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__